import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Ref } from 'vue';
import type { NotificationProps } from '@/types/models/common.d';

export const useNotificationStore = defineStore('notification', () => {
  /** 現在表示中の通知。undefinedなら非表示 */
  const notification: Ref<NotificationProps | undefined> = ref(undefined);

  return { notification };
});
